import PropTypes from 'prop-types'
import * as Yup from 'yup'
import Button from 'react-bootstrap/Button'
import Form from '~/components/shared/Form'
import withLocale from '~/hocs/locale'
import AsAnonymousInput from '../AsAnonymousInput'
import '~/utils/extended-validation'

const VALIDATION = Yup.object({
  body: Yup.string().trim().required().label('comment'),
})

const CommentForm = ({
  submitText,
  submittingText,
  onSubmit,
  showSkip,
  skipText,
  placeholder,
  bodyLabel,
}) => {
  const onSkip = () => {
    onSubmit({})
  }

  return (
    <Form
      validationSchema={VALIDATION}
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={{
        asAnonymous: false,
        body: '',
      }}
      onSubmit={onSubmit}
    >
      <Form.Field
        label={bodyLabel}
        as="textarea"
        name="body"
        placeholder={placeholder}
        rows={3}
      />
      <div className="d-flex justify-content-between">
        <AsAnonymousInput name="asAnonymous" />
        {!showSkip &&
          <Form.Submit text={submitText} submittingText={submittingText} size="lg" type="submit" />}
      </div>
      {!!showSkip && (
        <div className="text-right">
          <Button size="lg" variant="outline-primary" className="mr-2" onClick={onSkip}>{skipText}</Button>
          <Form.Submit text={submitText} submittingText={submittingText} size="lg" type="submit" />
        </div>
      )}
    </Form>
  )
}

CommentForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  submittingText: PropTypes.string.isRequired,
  skipText: PropTypes.string.isRequired,
  showSkip: PropTypes.bool,
  placeholder: PropTypes.string,
  bodyLabel: PropTypes.string,
}

CommentForm.defaultProps = {
  showSkip: false,
  placeholder: '',
  bodyLabel: '',
}

export default withLocale('common', 'commentForm')(CommentForm)
